import { connect } from 'react-redux';

import { StudyDetails } from 'es6/components/home/study-details';

export function mapStateToProps({ env }) {
  let isContentCreationEnabled = false;

  const siteConfiguration = env ? env.siteConfiguration : undefined;

  if (siteConfiguration) {
    isContentCreationEnabled = siteConfiguration.features.contentCreation;
  }

  return {
    isContentCreationEnabled,
  };
}

export default connect(mapStateToProps)(StudyDetails);
